import { gql } from '__generated__';

export const GET_TENANTS = gql(/* GraphQL */ `
  query getTenants($tenantsInput: TenantsInput!) {
    tenants(tenantsInput: $tenantsInput) {
      id
      name
      isSuperTenant
      timezone
    }
  }
`);
